import { ref } from 'vue-demi';

function initialsToUpperCase(val) {
	return String(val).toLowerCase().replace(/^\S/, s => s.toUpperCase());
}

function nullString(val) {
	if (val === 'null' || val === 'NULL') {
		return initialsToUpperCase(val);
	}
	return val;
}

export function useNullString(initialValue) {
	const value = ref(initialValue);

	function handleInput(event) {
		value.value = nullString(event.target.value);
	}

	return {
		value,
		handleInput,
	};
}
